<template lang="pug">
component(v-bind="elementOptions")
    template(v-if="data.content")
        template(v-for="ele in data.content")
            Element(:data="ele" :linkColor="linkColor")
</template>

<script>
import TextRenderer from './content'

export default {
    name: 'Element',
    props: {
        data: {
            type: Object,
            default() {
                return {}
            },
        },
        linkColor: {
            type: String,
            default: '',
        },
    },
    computed: {
        elementOptions() {
            const options = {
                is: null,
                class: '',
            }

            switch (this.data.type) {
                case 'bullet_list':
                    options.is = 'ul'
                    break

                case 'ordered_list':
                    options.is = 'ol'
                    break

                case 'list_item':
                    options.is = 'li'
                    break

                case 'heading':
                    options.is = `h${this.data.attrs.level}`
                    break

                case 'text':
                    options.is = TextRenderer
                    options.data = this.data
                    options.linkColor = this.linkColor
                    break

                case 'paragraph':
                    options.is = 'p'
                    break

                case 'hard_break':
                    options.is = 'br'
                    break

                default:
                    options.is = 'div'
                    break
            }

            return options
        },
    },
}
</script>
